// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"bcb7fc30","448":"d7284870","453":"a46c142f","468":"74133c21","517":"c303a42a","520":"b99de797","588":"aeeb7f7a","786":"fe547f31","835":"e9e2b7ba"}[chunkId] + ".chunk.js";
};